(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('graphic-archive-item-ibq', {
            parent: 'entity',
            url: '/graphic-archive-item-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.graphicArchiveItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-itemsibq.html',
                    controller: 'GraphicArchiveItemIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('graphicArchiveItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('graphic-archive-item-ibq-detail', {
            parent: 'graphic-archive-item-ibq',
            url: '/graphic-archive-item-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.graphicArchiveItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-detail.html',
                    controller: 'GraphicArchiveItemIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('graphicArchiveItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GraphicArchiveItem', function($stateParams, GraphicArchiveItem) {
                    return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'graphic-archive-item-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('graphic-archive-item-ibq-detail.edit', {
            parent: 'graphic-archive-item-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('graphic-archive-item-ibq.new', {
            parent: 'graphic-archive-item-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                publicationDate: null,
                                publicationPlace: null,
                                note: null,
                                source: null,
                                title: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('graphic-archive-item-ibq');
                });
            }]
        })
        .state('graphic-archive-item-ibq.edit', {
            parent: 'graphic-archive-item-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-dialog.html',
                    controller: 'GraphicArchiveItemIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('graphic-archive-item-ibq.delete', {
            parent: 'graphic-archive-item-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/graphic-archive-item/graphic-archive-item-ibq-delete-dialog.html',
                    controller: 'GraphicArchiveItemIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GraphicArchiveItem', function(GraphicArchiveItem) {
                            return GraphicArchiveItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('graphic-archive-item-ibq', null, { reload: 'graphic-archive-item-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
